module.exports = __webpack_public_path__ + "media/images/app/subscriptions/hero-f0e8e48077ea0683eedf458a176d7c78.webp";